export const aboutInfo = {
  brand: {
    title: '关于日韩在线',
    subtitle: '正版日韩内容一站聚合平台',
    description: [
      '日韩在线成立于2024年，是国内领先的日韩文化内容聚合平台。我们致力于为中国用户提供最新、最全的日韩影视、音乐、综艺、资讯内容，让每一位日韩文化爱好者都能在这里找到属于自己的精神角落。',
      '我们与韩国三大电视台（KBS、MBC、SBS）、日本五大商业电视台（富士电视台、TBS、日本电视台、朝日电视台、东京电视台）以及多家国际流媒体平台建立了深度合作关系，确保平台内容的丰富性和时效性。',
      '截至目前，日韩在线已累计服务超过500万用户，日均活跃用户超过50万，平台内容总量超过3万部（集），覆盖日韩影视、综艺、动漫、音乐、资讯等多个领域。',
    ],
    mission: '让每一位日韩文化爱好者，都能无需翻墙，畅享正版优质内容。',
    vision: '成为中国最受信赖的日韩文化内容平台，连接中日韩文化交流的桥梁。',
  },
  values: [
    {
      icon: 'ri-shield-check-line',
      title: '正版保障',
      description: '所有内容均获得合法授权，坚决抵制盗版，保护创作者权益。',
    },
    {
      icon: 'ri-flashlight-line',
      title: '极速体验',
      description: '全球CDN加速，国内用户无需翻墙，高清流畅播放。',
    },
    {
      icon: 'ri-user-heart-line',
      title: '用户至上',
      description: '以用户体验为核心，持续优化产品功能，倾听每一位用户的声音。',
    },
    {
      icon: 'ri-global-line',
      title: '文化桥梁',
      description: '不仅提供内容，更致力于促进中日韩文化之间的交流与理解。',
    },
  ],
  milestones: [
    { year: '2024.03', event: '日韩在线正式上线，首批上线5000+部日韩影视内容' },
    { year: '2024.06', event: '注册用户突破100万，新增音乐和综艺频道' },
    { year: '2024.09', event: '与韩国KBS、MBC、SBS达成内容合作协议' },
    { year: '2024.12', event: '日活跃用户突破30万，获"年度最佳文化类应用"提名' },
    { year: '2025.03', event: '与日本富士电视台、TBS建立战略合作关系' },
    { year: '2025.06', event: '平台内容总量突破2万部，推出AI智能推荐系统' },
    { year: '2025.09', event: '注册用户突破300万，上线原创深度内容频道' },
    { year: '2026.01', event: '与Netflix、Disney+达成内容分发合作' },
    { year: '2026.06', event: '日活跃用户突破50万，启动全球化布局' },
  ],
  testimonials: [
    {
      name: '张先生',
      role: '资深日剧迷',
      content: '日韩在线真的是日剧迷的福音！资源更新速度超快，字幕质量也很高，再也不用到处找资源了。界面设计也很简洁清爽，使用体验非常好。',
      rating: 5,
    },
    {
      name: '李女士',
      role: 'K-POP粉丝',
      content: '作为追星女孩，日韩在线简直就是我的精神食粮。音乐频道不仅有最新打歌舞台，还有超多独家专访内容。最重要的是不用翻墙，速度还很快！',
      rating: 5,
    },
    {
      name: '王同学',
      role: '动漫爱好者',
      content: '从朋友那里知道日韩在线的，用了之后彻底爱上了。动漫频道更新超快，很多新番同步日本播出，画质也很清晰。强烈推荐给所有二次元爱好者。',
      rating: 5,
    },
    {
      name: '赵女士',
      role: '综艺达人',
      content: '每周必追的《Running Man》和《地球游乐厅》，日韩在线的更新速度和字幕质量都是一流的。综艺频道内容分类也很清晰，找节目非常方便。',
      rating: 4,
    },
    {
      name: '陈先生',
      role: '韩国电影爱好者',
      content: '日韩在线的电影频道资源很丰富，从经典老片到最新院线都有覆盖。画质很好，播放流畅，是我目前用过体验最好的日韩内容平台。',
      rating: 5,
    },
    {
      name: '刘女士',
      role: '日韩资讯关注者',
      content: '资讯频道每天都会推送最新的日韩娱乐新闻，时效性很强，文章质量也不错。对于我这种时刻关注日韩动态的人来说，太方便了。',
      rating: 5,
    },
  ],
  contact: {
    email: 'contact@rikkan-online.com',
    wechat: '日韩在线官方',
    weibo: '@日韩在线',
    address: '北京市朝阳区望京SOHO T3-A座 2501室',
    phone: '400-888-6688',
    businessHours: '周一至周五 9:00 - 18:00',
  },
  faq: [
    {
      question: '日韩在线是否需要付费？',
      answer: '日韩在线提供免费和会员两种服务模式。免费用户可观看大部分内容（含广告），会员用户可享受无广告、超清画质、独家内容等专属权益。会员定价为每月29元，年费会员仅需199元。',
    },
    {
      question: '日韩在线支持哪些设备？',
      answer: '日韩在线支持全平台访问，包括Web网页端、iOS App、Android App、智能电视（TV端）以及iPad平板端。一个账号可在多个设备间自由切换使用。',
    },
    {
      question: '内容更新频率如何？',
      answer: '日韩在线实行24小时不间断更新机制。电视剧和综艺节目在日本/韩国播出后4小时内上线中文字幕版；音乐打歌舞台当日更新；娱乐资讯全天候滚动推送，确保用户第一时间获取最新内容。',
    },
    {
      question: '是否需要翻墙才能使用？',
      answer: '完全不需要！日韩在线的所有服务器均部署在中国境内及周边优化节点，国内用户可直接访问，无需任何翻墙工具。我们使用了全球CDN加速技术，确保全国各地用户都能流畅观看。',
    },
    {
      question: '如何联系客服？',
      answer: '您可以通过以下方式联系我们的客服团队：发送邮件至 contact@rikkan-online.com，或在工作时间拨打客服热线 400-888-6688。我们的客服团队将在2小时内回复您的咨询。',
    },
  ],
};